import axios from 'axios'

export class Wasserquellenarten{
    static async get(){
        try {
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/wasserquellenarten',
            );

            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }
}
